export const PRODUCT_DIFFICULTY_LEVELS = {
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  ADVANCED: 'Advanced',
};

export const PRODUCT_VARIANT_TO_ENTITY_TYPE_MAPPING = {
  ProfessionalCertificateS12n: 'PROFESSIONAL CERTIFICATE',
};
